module.exports = __webpack_public_path__ + "static/media/om_eyebrowshape_rounded_vector.03c98d89.svg";